export default __webpack_public_path__ + "static/media/tooltip.f3474a95.svg";